import {
	hydrateTopicCloudShells,
	initializeTopicClouds,
} from "../../modules/topic-cloud";

document.addEventListener("DOMContentLoaded", () => {
	hydrateTopicCloudShells(document);
	initializeTopicClouds(document);
});
